import React from 'react';
import { ArrayHelpers, DomHelpers, Help, Paging, SystemText } from 'e4shared';
import { ratingColour } from 'helpers/metrics';
import CompetencyExtraData from '../components/competencyExtraData';
import { translate } from 'helpers/translations';
import { useSelector } from 'react-redux';

export const Board = ({ data, item, id, type }) => {
    const loaded = React.useRef(null);
    const [pagedData, setPagedData] = React.useState([]);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(6);
    const [width, setWidth] = React.useState(200);
    const [hasPIs, setHasPIs] = React.useState(false);
    const { user } = useSelector(state => state.user);
    const recordCount = data.length;

    React.useEffect(() => {
        const pageSizeGenerator = extra => {
            const rowHeight = 40;
            const extrasHeight = 50;
            const me = document.querySelector(`#${id}`);
            if (me) setWidth(me.offsetWidth - 70 - (extra ? 10 : 0));
            let result = me ? ((me.offsetHeight - extrasHeight) / rowHeight).toFixed() : 10;
            if (result < recordCount) result--;
            return result < 0 ? 0 : result;
        };

        const dataHasSomePIs = data.some(d => ArrayHelpers.existsAndHasLength(d.extraData));
        setHasPIs(dataHasSomePIs);
        const ps = pageSizeGenerator(dataHasSomePIs);

        setPagedData(ArrayHelpers.getPage(data, page, ps));
        setPageSize(ps);
    }, [id, item.h, item.w, page, data]);

    React.useEffect(() => {
        data && loaded.current && DomHelpers.truncateText('ellipse', loaded.current, 0);
    }, [data, loaded.current]);

    return (
        <div ref={loaded}>
            {ArrayHelpers.existsAndHasLength(pagedData) ? (
                <table className="table table-condensed">
                    <tbody>
                        <tr>
                            <th>{SystemText('Dashboard/Widgets/FocusCompetencies/Table/Headers/Competency')}</th>
                            <th width="1" className="text-right"></th>
                            {type === 'AVG' && hasPIs && <th width="1" className="text-right"></th>}
                        </tr>
                        {pagedData.map((t, i) => {
                            t.name = translate(user.language_Code, t, 'Name', t.name);
                            t.extra = translate(user.language_Code, t, 'Name', t.extra, 'extra_Translations');
                            return (
                                <tr key={i}>
                                    <td className="no-wrap">
                                        <div className="flex flex-center">
                                            <i className="fa fa-star mr10" />
                                            <div
                                                style={{
                                                    maxWidth: `${width - 10}px`,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                }}
                                            >
                                                {t.extra} - {t.name}
                                            </div>
                                        </div>
                                    </td>
                                    <td style={null} className="no-wrap text-right">
                                        {type === 'AVG' ? (
                                            <label className={`label label-${ratingColour(t.value)}`}>
                                                {t.value ? t.value.toFixed(1) : 0}
                                            </label>
                                        ) : (
                                            <div>
                                                {t.quota}
                                                <i className="fa fa-flag text-danger ml10" />
                                            </div>
                                        )}
                                    </td>
                                    {type === 'AVG' && hasPIs && (
                                        <td style={{ paddingLeft: '0' }}>
                                            <CompetencyExtraData competency={t} id={`${id}-${i}`} />
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            ) : (
                <div>{SystemText('Dashboard/Widgets/FocusCompetencies/NoResults')}</div>
            )}

            {recordCount > pageSize && (
                <div className="text-center mt10">
                    <Paging
                        page={page}
                        narrow={item.w < 3}
                        pageSize={pageSize}
                        recordCount={recordCount}
                        goToPage={setPage}
                    />
                </div>
            )}
        </div>
    );
};

export default Board;
